module.exports = __webpack_public_path__ + "media/flags/cz-35da24ee.svg";